<template>
  <div
    v-show="open"
    class="modal"
  >
    <div
      class="modal-overlay"
      @click="closeModal"
    />
    <div
      class="modal-container"
      :style="Style ? Style : { width, maxWidth, height, overflow: overflow, margin }"
    >
      <div
        v-if="showModalCloseIcon"
        class="modal-close-icon"
        @click="closeModal(true)"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 20 20"
          enable-background="new 0 0 20 20"
          xml:space="preserve"
        >
          <path
            d="M10,1.6c-4.639,0-8.4,3.761-8.4,8.4c0,4.639,3.761,8.4,8.4,8.4s8.4-3.761,8.4-8.4C18.4,5.361,14.639,1.6,10,1.6z
                    M14.789,13.061l-1.729,1.729L10,11.729l-3.061,3.06l-1.729-1.729L8.272,10L5.211,6.939L6.94,5.211L10,8.271l3.061-3.061
                    l1.729,1.729L11.728,10L14.789,13.061z"
          />
        </svg>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'open',
    event: 'toggleState',
  },
  props: {
    open: Boolean,
    // clicking outside of modal closes modal
    clickOutside: {
      type: Boolean,
      default: true,
    },
    // escape key closes modal
    escape: {
      type: Boolean,
      default: true,
    },
    width: {
      default: '50%',
      type: String,
    },
    maxWidth: {
      default: 'none',
      type: String,
    },
    height: {
      default: '50%',
      type: String,
    },
    overflow: {
      default: '',
      type: String,
    },
    margin: {
      default: '',
      type: String,
    },
    showModalCloseIcon: {
      default: true,
      type: Boolean,
    },
    styles: { type: Object, default: null },
  },
  watch: {
    open: function (newValue) {
      if (newValue) {
        if (this.escape) {
          document.addEventListener('keydown', this.closeModalFromListener);
        }
        if (this.clickOutside) {
          this.$el.addEventListener('click', this.closeModalFromListener);
        }

        const body = document.querySelector('body');
        body.classList.add('noscroll');
      } else {
        const body = document.querySelector('body');
        body.classList.remove('noscroll');
      }
    },
  },
  mounted() {
    if (this.escape) {
      document.addEventListener('keydown', this.closeModalFromListener);
    }
  },
  computed: {
    Style() {
      if (!this.styles) return null;
      return {
        width: this.width,
        maxWidth: this.maxWidth,
        height: this.height,
        overflow: this.overflow,
        margin: this.margin,
        ...this.styles,
      };
    },
  },
  methods: {
    openModal() {
      this.$emit('toggleState', true);
    },
    closeModal(fromIcon) {
      if (!fromIcon && !this.clickOutside) {
        return;
      }
      this.$emit('toggleState', false);
    },
    closeModalFromListener: function (e) {
      // escape key
      if (e.keyCode === 27) {
        this.closeModal();
        document.removeEventListener('keydown', this.closeModalFromListener);
      }
    },
  },
};
</script>

<style scoped lang="scss">
// @import 'dv/lib/SASS/_vars.scss';
.modal {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.modal-overlay {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 10, 50, 0.5);
}
.modal-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  overflow-y: auto;
  background: white;
  border: 4px solid $indBlue;
  box-shadow: 0 6px 13px 1px rgba(50, 50, 50, 0.5);
  // override from parent if square modal needed
  border-radius: $mdBordRad;
}
.modal-close-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 20px;
  cursor: pointer;
}
</style>

<style lang="scss">
.noscroll {
  overflow: hidden;
}
</style>
